import { siteSettingsData } from "redux/reduxToolkitServices/_commonReducers/commonReducers";

export const batteryCritical = function (car) {
    let batteryLevel = {
        warning: 25,
        critical: 10
     };
    return siteSettingsData.GuardianCapable && !car.IsCharging && (car.BatteryLevel <= batteryLevel.critical);
 };